import React, { useContext, useEffect } from "react";
// import ProjectListSideBar from "./ProjectListSideBar";
import TaskList from "./TaskList";
import { Box } from "@mui/material";
import { useState } from "react";
import { useGetProjects } from "./projectHooks";
// import { AuthContext } from "../../../../context/authContext";
import { AuthContext } from "../../../../../../context/authContext";
import { useParams } from "react-router-dom";
import HeadingComponent from "../../../../../../components/HeadingComponent";
import { DCSProvider } from "../../../../AllEquipments/CommonFeatures/DCSTab/Table/DCSContext";

const ProjectTasksPage = ({ catList, type = "Engineering", plant = false }) => {
  const { id } = useParams("id");
  const { accessToken } = useContext(AuthContext);
  const {
    data,
    isError: isLoadingItemsError,
    isFetching,
    isLoading,
  } = useGetProjects({ accessToken });
  const [selectedProject, setSelectedProject] = useState({});

  useEffect(() => {
    console.log("dddddds", data, id, catList);

    if (data) {
      let selectedProjectData = data.find((project) => project.id == id);
      console.log("selected data ", selectedProjectData, id);

      setSelectedProject(selectedProjectData);
      console.log("selectedddd", selectedProjectData);
    }
  }, [id, data]);

  const content = (
    <Box padding={"2rem"}>
      <HeadingComponent heading="Tasks" />
      <TaskList
        selectedProject={selectedProject}
        catList={catList}
        type={type}
      />
    </Box>
  );

  if (!data) return null;

  if (catList) {
    return content;
  }

  return (
    <DCSProvider type={type} plant={plant}>
      {content}
    </DCSProvider>
  );
};

export default ProjectTasksPage;
